module.exports = __webpack_public_path__ + "static/frolic-icon-small-6cff8a705cee059bd924df3460ee9830.png";